module.exports = __webpack_public_path__ + "static/media/angripe.c8e0972c.m4a";